// Pages whose click text may go to Laftel Analytics. Everywhere else the text on screen is the learner's own
// content (flashcards, account), so the app shell marks it data-l-private: clicks still count, without text.
const PUBLIC_PATHS = new Set(['/', '/login', '/login/verify', '/privacy-policy', '/terms-of-service', '/feedback']);

export function isPublicPath(pathname) {
  return PUBLIC_PATHS.has(pathname);
}

// Named actions and the signed-in flag. The loader in public/index.html queues calls until the tracker loads;
// elsewhere (local dev, tests) they do nothing. Event names match the mobile app's (frontend-mobile/src/lib/analytics.ts).
export const track = (name, props) => window.laftel?.track?.(name, props);

export const setSignedIn = (value) => window.laftel?.signedIn?.(value);
